import { useEffect, useRef, useState } from "react";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../assets/toastUtils";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Header/Header";
import NewSearchSateInput from "../../../NewSearchSateInput/NewSearchSateInput";
import Flatpickr from "react-flatpickr";
import styles from "./NewUiSearchFormHotels.module.scss";
import { calculateToDatePlus } from "../../../../utils/utils";
import NewUiHeader from "../../NewUIHeader/NewUIHeader";
import { SvgRightIcon, SvgSearch } from "../../../../utils/svgIcons";
import HomePageNewSearchSateInput from "../../../NewSearchSateInput/HomePageNewSearchSateInput";

import DatePicker from "react-datepicker";
import { format, addDays } from "date-fns";
import GuestDetailsPopup from "./GuestDetailsPopup";
import { toast } from "react-toastify";

function NewUiSearchFormHotels({ topRadios }) {
  const [dataFromChild, setDataFromChild] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [bookingData, setBookingData] = useState({});
  const [show, setShow] = useState(false);
  const location = useLocation();

  const [width, setWidth] = useState(window.innerWidth);

  const [roomsData, setRoomsData] = useState([]);

  // popup details
  const [storeRoomsData, setStoreRoomsData] = useState([
    { id: 1, adult: 2, children: [] },
  ]);
  const [adult, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);
  const [rooms, setRooms] = useState(1);

  // const addRoom = () => {
  //   if (storeRoomsData.length >= 6) return;
  //   const newRoomId = storeRoomsData.length + 1;
  //   const newRooms = [
  //     ...storeRoomsData,
  //     { id: newRoomId, adult: 1, children: [] },
  //   ];
  //   setStoreRoomsData(newRooms);
  //   setRooms(newRooms.length); // Update the room count
  //   updateTotalAdults(newRooms);
  // };

  const addRoom = () => {
    setStoreRoomsData((prevRooms) => {
      if (prevRooms.length >= 6) return prevRooms;

      const newRoomId =
        prevRooms.length > 0 ? prevRooms[prevRooms.length - 1].id + 1 : 1;
      const newRooms = [
        ...prevRooms,
        { id: newRoomId, adult: 1, children: [] },
      ];

      setRooms(newRooms.length);
      updateTotalAdults(newRooms);

      return newRooms;
    });
  };

  const removeRoom = (roomId) => {
    const newRooms = storeRoomsData.filter((room) => room.id !== roomId);
    setStoreRoomsData(newRooms);
    setRooms(newRooms.length); // Update the room count
    updateTotalAdults(newRooms);

    const childrens = newRooms?.flatMap((child) => child?.children);

    setChildren(childrens?.length);
  };

  const updateTotalAdults = (updatedRooms) => {
    const totalAdults = updatedRooms.reduce((sum, room) => sum + room.adult, 0);
    setAdults(totalAdults);
  };

  const onAdultIncrease = (roomId) => {
    const updatedRooms = storeRoomsData.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.min(room.adult + 1, 4) }
        : room
    );
    setStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const onAdultDecrease = (roomId) => {
    const updatedRooms = storeRoomsData.map((room) =>
      room.id === roomId
        ? { ...room, adult: Math.max(room.adult - 1, 1) }
        : room
    );
    setStoreRoomsData(updatedRooms);
    updateTotalAdults(updatedRooms);
  };

  const addChildAge = (roomId, age) => {
    const room = storeRoomsData.find((room) => room.id === roomId);
    if (room && room.children.length >= 3) {
      toast.error("You can add a maximum of 3 children in one room.");
      return;
    }

    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? room.children.length < 3
            ? {
              ...room,
              children: [...room.children, age],
              showGuestDetailsPopup: !room.showGuestDetailsPopup,
            }
            : room
          : room
      )
    );

    // if (childAge.length < 3) {
    setChildren(Number(children) + 1);
    setChildAge([...childAge, age]);
    // }
  };

  const removeChild = (roomId, indexToRemove) => {
    let removedAge;
    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === roomId) {
          removedAge = room.children[indexToRemove];
          return {
            ...room,
            children: room.children.filter(
              (_, index) => index !== indexToRemove
            ),
          };
        }
        return room;
      })
    );
    setChildren(children - 1);
    setChildAge(
      childAge.filter((_, index) => index !== childAge.indexOf(removedAge))
    );
  };

  const toggleGuestDetailsPopup = (roomId) => {
    setStoreRoomsData((prevRooms) =>
      prevRooms.map((room) =>
        room.id === roomId
          ? { ...room, showGuestDetailsPopup: !room.showGuestDetailsPopup }
          : room
      )
    );
  };
  // end popup details

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      // hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      checkoutDay: params.get("checkoutDay"),
      checkoutMonth: params.get("checkoutMonth"),
      checkoutYear: params.get("checkoutYear"),
      radio: params.get("radio"),
      childAge: childAges, // Assign the array of child ages
    };
    // console.log(hotelData, "data hotel")
    setBookingData(data);
    // postBookingData(data);
  }, [location.search]);

  const getDataFromChild = (data, resultArray, selectedType) => {
    setDataFromChild(data);
    setSelectedType(selectedType);
  };
  // console.log(dataFromChild, "getDataFromChild");

  const handleStartDateChange = ([date]) => {
    setStartDate(date);
    // Automatically set end date to the selected start date if it's not already set
    if (!endDate || date > endDate) {
      setEndDate(date);
    }
  };

  const handleEndDateChange = ([date]) => {
    setEndDate(date);
  };

  const [guestDetails, setIsguestDetails] = useState(false);
  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectDates, setselectDates] = useState(false);

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  const [checkin, setCheckin] = useState({
    day: checkinDay,
    month: checkinMonth,
    year: checkinYear,
  });

  const [checkout, setCheckout] = useState({
    day: checkoutDay,
    month: checkoutMonth,
    year: checkoutYear,
  });
  const navigate = useNavigate();

  // STATES
  const [date, setDate] = useState(new Date());
  const [selectedRadio, setSelectedRadio] = useState("s");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });

  const showErrorToast = (message) => {
    alert(message); // You can use a better toast notification library
  };

  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(calculateToDatePlus(new Date(), 1));

  const [startDate, setStartDate] = useState(() => {
    const start = new Date();
    start.setDate(start.getDate() + 7);
    return start;
  });

  // End date is 8 days from today (1 day after start)
  const [endDate, setEndDate] = useState(() => {
    const end = new Date();
    end.setDate(end.getDate() + 8);
    return end;
  });

  //

  // Date alterations
  const [loader, setLoader] = useState(false);

  // const [checkin, setCheckin] = useState({
  //   day: router.query.checkinDay || "",
  //   month: router.query.checkinMonth || "",
  //   year: router.query.checkinYear || "",
  // });

  // const [checkout, setCheckout] = useState({
  //   day: router.query.checkoutDay || "",
  //   month: router.query.checkoutMonth || "",
  //   year: router.query.checkoutYear || "",
  // });

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };

  // Effect to add click event listener when guestDetails is true
  useEffect(() => {
    if (guestDetails) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [guestDetails]);

  useEffect(() => {
    if (
      checkinDay &&
      checkinMonth &&
      checkinYear &&
      checkoutDay &&
      checkoutMonth &&
      checkoutYear
    ) {
      const formatDateToString = (year, month, day) => {
        const paddedMonth = String(month).padStart(2, "0");
        const paddedDay = String(day).padStart(2, "0");
        return `${year}-${paddedMonth}-${paddedDay}`;
      };

      const checkInDateString = formatDateToString(
        checkinYear,
        checkinMonth,
        checkinDay
      );
      const checkOutDateString = formatDateToString(
        checkoutYear,
        checkoutMonth,
        checkoutDay
      );

      const checkInDate = new Date(checkInDateString);
      const checkOutDate = new Date(checkOutDateString);

      setStartDate(checkInDate);
      setEndDate(checkOutDate);
    }
  }, [
    checkinDay,
    checkinMonth,
    checkinYear,
    checkoutDay,
    checkoutMonth,
    checkoutYear,
  ]);

  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  // const onAdultIncrease = () => {
  //   const newAdult = adult + 1;
  //   setAdults(newAdult);
  //   if (newAdult > 1 && newAdult % 2 === 0 && rooms < newAdult / 2) {
  //     setRooms(rooms + 1);
  //   }
  // };

  // const onAdultDecrease = () => {
  //   if (adult > 1) {
  //     const newAdult = adult - 1;
  //     setAdults(newAdult);
  //     if (newAdult % 2 !== 0 && rooms > 1) {
  //       setRooms(rooms - 1);
  //     }
  //   }
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const handleSubmitButtonClickHandler = async (e) => {
    e.preventDefault();

    if (!startDate || !endDate) {
      showErrorToast("Fill required detail first");
      return;
    }

    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    try {
      const encodedRoomsData = encodeURIComponent(
        JSON.stringify(storeRoomsData)
      );
      await navigate(
        `/listing-hotels?hotelID=1&location=${dataFromChild}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&radio=${selectedRadio}&selected_destinations=${dataFromChild}&storeRoomsData=${encodedRoomsData}`,
        // {
        //   state: {
        //     storeRoomsData: storeRoomsData,
        //   },
        // },
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  // console.log("selectedType", selectedType);
  const handleSubmitButtonClickHandlerHotels = async (e) => {
    e.preventDefault();

    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }
    try {
      await navigate(
        // `/single-hotel/${selectedType?.id}?hotelId=${selectedType?.id}&location=${selectedType.location}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}&hotel_name=${selectedType.name}&hotel_address=${selectedType.location}`,
        `/single-hotel/${selectedType?.slug}/${selectedType?.id}?&location=${selectedType?.location
        }&room=${rooms}&adult=${adult}&children=${children}&${childAgeParams}&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(endDate).getFullYear()}&hotel_name=${selectedType?.name
        }&hotel_address=${selectedType?.location},`,
        {
          state: {
            storeRoomsData: storeRoomsData,
          },
        }
        // single-hotel/1?hotelId=1&location=Shimla&room=1&adult=2&children=0&checkinDay=4&checkinMonth=10&checkinYear=2024&checkoutDay=5&checkoutMonth=10&checkoutYear=2024&hotel_name=Golden%20Fern%20Resort%20by%20Eco%20Hospitality&hotel_address=Kachi%20Ghatti,%20Shimla,%20Himachal%20Pradesh%20171010
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);
  const [showGuestDetailsPopup, setShowGuestDetailsPopup] = useState(false);
  const availableAges = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  const handleclosePopup = () => {
    setIsguestDetails(false);
  };

  return (
    <>
      {/* <Header /> */}
      <NewUiHeader />

      {width <= 640 && (
        <div className={styles.NewUiSearchWrapperMobile}>
          <div
            className={styles.NewUiSearchParentMobile}
            onClick={() => {
              setShow((prev) => !prev);
              setIsguestDetails(false);
              setdestinationToggle(false);
            }}
          >
            <div>
              <SvgSearch />
            </div>

            <div>Where would you like to go ?</div>

            <div>
              <SvgRightIcon />
            </div>
          </div>

          {show && (
            <form
              className={styles.NewUiSearchWrapperFormMobile}
              onSubmit={
                selectedType?.type === "hotel"
                  ? handleSubmitButtonClickHandlerHotels
                  : handleSubmitButtonClickHandler
              }
            >
              <div className={styles.widthOfDestination}>
                <label htmlFor="">
                  <small>CITY/DESTINATION/HOTEL</small>{" "}
                </label>
                <NewSearchSateInput
                  onClick={() => setdestinationToggle(true)}
                  onDataChange={getDataFromChild}
                  setIsguestDetails={setIsguestDetails}
                  type="hotel"
                />
              </div>

              <div
                className={`${styles.leftLineBorder} ${styles.widthOfDestination} new_date_picker_react_js_custom_styling`}
                setStartDate={setStartDate}
              >
                <label>DATES </label>

                {/* <Flatpickr
                  className="search_form_input"
                  value={[startDate, endDate]}
                  onChange={([date1, date2]) => {
                    setStartDate(date1 || null);
                    setEndDate(date2 || null);
                  }}
                  options={{ mode: "range", minDate: "today" }}
                  required
                /> */}

                <div className={styles.new_date_picker_wrapper}>
                  <DatePicker
                    selected={startDate}
                    onChange={(dates) => {
                      const [start, end] = dates;
                      setStartDate(start);
                      setEndDate(end);
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()} // Prevent past dates selection
                    dateFormat="dd MMM, yyyy"
                    placeholderText={`${format(
                      startDate,
                      "dd MMM, yyyy"
                    )} - ${format(endDate, "dd MMM, yyyy")}`}
                  />
                </div>
              </div>
              <div className={styles.leftLineBorder}>
                <label onClick={dropdownGuestDetails} className="search_label">
                  ROOM & GUEST
                  <svg
                    width="9"
                    height="5"
                    viewBox="0 0 9 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8.25 0.75L4.75 4.25L1.25 0.75" stroke="#BB735D" />
                  </svg>
                </label>
                <p
                  id="relative_position"
                  className="dropdown-toggle search_form_input"
                  onClick={() => setdestinationToggle(true)}
                >
                  <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                    <d iv className="optionCounter"></d>
                    <span className="font_16" id="adult_count">
                      <b> {adult}</b>
                    </span>
                    <span className="font_12"> Adults,</span>{" "}
                    <span className="font_16" id="room_count">
                      <b> {rooms}</b>
                    </span>
                    <span className="font_12"> Rooms, </span>{" "}
                    <span className="font_16" id="child_count">
                      <b> {children}</b>
                    </span>
                    <span className="font_12"> Children</span>
                  </div>
                  {guestDetails && (
                    // <div
                    //   className="guest_details_dropdown"
                    //   id="guestDetailsPopup"
                    // >
                    //   <div className="agent">
                    //     <span>Adult</span>
                    //     <div>
                    //       <button
                    //         type="button"
                    //         disabled={adult <= 1}
                    //         className="optionCounterButton optionCounterButtonWithBorder"
                    //         onClick={onAdultDecrease}
                    //       >
                    //         <span className="onclick_btn" id="adult_minus">
                    //           -
                    //         </span>
                    //       </button>

                    //       <input
                    //         className="optionCounterNumber"
                    //         value={adult}
                    //         min={1}
                    //       />

                    //       <button
                    //         type="button"
                    //         // disabled={rooms <= 1}
                    //         className="optionCounterButton optionCounterButtonWithBorder"
                    //         onClick={onAdultIncrease}
                    //       >
                    //         <span className="onclick_btn" id="adult_plus">
                    //           +
                    //         </span>
                    //       </button>
                    //     </div>
                    //   </div>
                    //   <div className="agent">
                    //     <span>Rooms</span>
                    //     <div>
                    //       <button
                    //         type="button"
                    //         disabled={rooms <= 1}
                    //         className="optionCounterButton optionCounterButtonWithBorder"
                    //         onClick={() => setRooms(Number(rooms) - 1)}
                    //       >
                    //         <span className="onclick_btn" id="adult_minus">
                    //           -
                    //         </span>
                    //       </button>

                    //       <input
                    //         className="optionCounterNumber"
                    //         value={rooms}
                    //         min={1}
                    //       />

                    //       <button
                    //         type="button"
                    //         // disabled={rooms <= 1}
                    //         className="optionCounterButton optionCounterButtonWithBorder"
                    //         onClick={() => setRooms(Number(rooms) + 1)}
                    //       >
                    //         <span className="onclick_btn" id="adult_plus">
                    //           +
                    //         </span>
                    //       </button>
                    //     </div>
                    //   </div>
                    //   <div>
                    //     {childAge.map((age, index) => (
                    //       <div
                    //         className="agent flex items-center gap-2"
                    //         key={index}
                    //       >
                    //         <span>
                    //           Child{" "}
                    //           <small style={{ fontSize: "12px" }}>
                    //             {" "}
                    //             ({age} Yrs){" "}
                    //           </small>
                    //         </span>
                    //         <div
                    //           className="remove_svg"
                    //           onClick={() => handleRemoveChild(index)}
                    //         >
                    //           <svg
                    //             width="18"
                    //             height="18"
                    //             viewBox="0 0 18 18"
                    //             fill="none"
                    //             xmlns="http://www.w3.org/2000/svg"
                    //           >
                    //             <mask
                    //               id="mask0_6577_13294"
                    //               style={{ maskType: "alpha" }}
                    //               maskUnits="userSpaceOnUse"
                    //               x="0"
                    //               y="0"
                    //               width="18"
                    //               height="18"
                    //             >
                    //               <rect width="18" height="18" />
                    //             </mask>
                    //             <g mask="url(#mask0_6577_13294)">
                    //               <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                    //             </g>
                    //           </svg>
                    //         </div>
                    //       </div>
                    //     ))}

                    //     {/* Add a child button */}
                    //     <div
                    //       className="flex align_items_center justify_content_between border"
                    //       style={{
                    //         padding: "10px ",
                    //         marginBottom: "10px",
                    //         fontWeight: "400",
                    //       }}
                    //       onClick={() =>
                    //         setShowGuestDetailsPopup(!showGuestDetailsPopup)
                    //       }
                    //     >
                    //       Add a Child
                    //       <div>
                    //         <svg
                    //           width="12"
                    //           height="6"
                    //           viewBox="0 0 12 6"
                    //           fill="none"
                    //           xmlns="http://www.w3.org/2000/svg"
                    //         >
                    //           <path
                    //             d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                    //             fill="#1C1B1F"
                    //           />
                    //         </svg>
                    //       </div>
                    //     </div>

                    //     {/* Child age selection popup */}
                    //     {showGuestDetailsPopup && (
                    //       <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                    //         {availableAges.map((age, i) => (
                    //           <div
                    //             className="new-age-option"
                    //             key={i}
                    //             onClick={() => handleAddChildAge(age)}
                    //             style={{ fontWeight: "400" }}
                    //           >
                    //             {age} Years
                    //           </div>
                    //         ))}
                    //       </div>
                    //     )}
                    //   </div>
                    // </div>
                    <GuestDetailsPopup
                      buttonName="Search"
                      adult={adult}
                      setAdults={setAdults}
                      children={children}
                      setChildren={setChildren}
                      rooms={storeRoomsData}
                      setRooms={setStoreRoomsData}
                      onRoomsChange={setStoreRoomsData}
                      handleRoomsUpdate={setStoreRoomsData}
                      setChildAge={setChildAge}
                      onAdultChange={setAdults}
                      childAge={childAge}
                      removeRoom={removeRoom}
                      onAdultIncrease={onAdultIncrease}
                      onAdultDecrease={onAdultDecrease}
                      toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                      addRoom={addRoom}
                      addChildAge={addChildAge}
                      removeChild={removeChild}
                      availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                      setIsguestDetails={setIsguestDetails}
                    />
                  )}
                </p>
              </div>

              <button type="submit" className={styles.submitButton}>
                SEARCH
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <mask
                      id="mask0_6818_5962"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="15"
                      height="15"
                    >
                      <rect width="15" height="15" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6818_5962)">
                      <path
                        d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                </span>
              </button>
            </form>
          )}
        </div>
      )}

      <section
        onClick={() => setShow(false)}
        className={styles.NewUiSearchWrapper}
        id="home"
      >
        <div className={styles.NewUiSearchParent}>
          <h1 className="text-center">
            Find Best Hotels & Resorts <br />
            in Himachal Pradesh
          </h1>
          <div
            className=""
            style={
              guestDetails || destinationToggle
                ? { zIndex: "999" }
                : { position: "" }
            }
          >
            {width > 640 && (
              <form
                className={styles.NewUiSearchFormWrapper}
                onSubmit={
                  selectedType?.type === "hotel"
                    ? handleSubmitButtonClickHandlerHotels
                    : handleSubmitButtonClickHandler
                }
              >
                <div className={styles.widthOfDestination}>
                  <label htmlFor="">DESTINATION/HOTEL</label>
                  {/* <SearchStateInput
                        onClick={() => setdestinationToggle(true)}
                        onDataChange={getDataFromChild}
                        setIsguestDetails={setIsguestDetails}
                      /> */}
                  <HomePageNewSearchSateInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    setIsguestDetails={setIsguestDetails}
                    type="hotel"
                  />
                  {/* <NewSearchSateInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    setIsguestDetails={setIsguestDetails}
                    type="hotel"
                  /> */}
                </div>

                <div
                  className={`${styles.leftLineBorder} ${styles.widthOfDestination} new_date_picker_react_js_custom_styling`}
                  setStartDate={setStartDate}
                >
                  <label>DATES</label>
                  {/* <Flatpickr
                    className="search_form_input"
                    value={[startDate, endDate]}
                    onChange={([date1, date2]) => {
                      setStartDate(date1 || null);
                      setEndDate(date2 || null);
                    }}
                    options={{ mode: "range", minDate: "today" }}
                    required
                  /> */}

                  <div className={styles.new_date_picker_wrapper}>
                    <DatePicker
                      selected={startDate}
                      onChange={(dates) => {
                        const [start, end] = dates;
                        setStartDate(start);
                        setEndDate(end);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()} // Prevent past dates selection
                      dateFormat="dd MMM, yyyy"
                      placeholderText={`${format(
                        startDate,
                        "dd MMM, yyyy"
                      )} - ${format(endDate, "dd MMM, yyyy")}`}
                    />
                  </div>
                </div>
                <div className={styles.leftLineBorder}>
                  <label
                    onClick={dropdownGuestDetails}
                    className="search_label"
                  >
                    ROOM & GUEST
                    <svg
                      width="9"
                      height="5"
                      viewBox="0 0 9 5"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.25 0.75L4.75 4.25L1.25 0.75"
                        stroke="#BB735D"
                      />
                    </svg>
                  </label>
                  <p
                    style={{ position: "relative" }}
                    className="dropdown-toggle search_form_input"
                    onClick={() => setdestinationToggle(true)}
                  >
                    <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                      <d iv className="optionCounter"></d>
                      <span className="font_16" id="adult_count">
                        <b> {adult}</b>
                      </span>
                      <span className="font_12"> Adults,</span>{" "}
                      <span className="font_16" id="room_count">
                        <b> {rooms}</b>
                      </span>
                      <span className="font_12"> Rooms, </span>{" "}
                      <span className="font_16" id="child_count">
                        <b> {children}</b>
                      </span>
                      <span className="font_12"> Children</span>
                    </div>
                    {guestDetails && (
                      // <div
                      //   className="guest_details_dropdown"
                      //   id="guestDetailsPopup"
                      // >
                      //   <div className="agent">
                      //     <span>Adult</span>
                      //     <div>
                      //       <button
                      //         type="button"
                      //         disabled={adult <= 1}
                      //         className="optionCounterButton optionCounterButtonWithBorder"
                      //         onClick={onAdultDecrease}
                      //       >
                      //         <span className="onclick_btn" id="adult_minus">
                      //           -
                      //         </span>
                      //       </button>

                      //       <input
                      //         className="optionCounterNumber"
                      //         value={adult}
                      //         min={1}
                      //       />

                      //       <button
                      //         type="button"
                      //         // disabled={rooms <= 1}
                      //         className="optionCounterButton optionCounterButtonWithBorder"
                      //         onClick={onAdultIncrease}
                      //       >
                      //         <span className="onclick_btn" id="adult_plus">
                      //           +
                      //         </span>
                      //       </button>
                      //     </div>
                      //   </div>
                      //   <div className="agent">
                      //     <span>Rooms</span>
                      //     <div>
                      //       <button
                      //         type="button"
                      //         disabled={rooms <= 1}
                      //         className="optionCounterButton optionCounterButtonWithBorder"
                      //         onClick={() => setRooms(Number(rooms) - 1)}
                      //       >
                      //         <span className="onclick_btn" id="adult_minus">
                      //           -
                      //         </span>
                      //       </button>

                      //       <input
                      //         className="optionCounterNumber"
                      //         value={rooms}
                      //         min={1}
                      //       />

                      //       <button
                      //         type="button"
                      //         // disabled={rooms <= 1}
                      //         className="optionCounterButton optionCounterButtonWithBorder"
                      //         onClick={() => setRooms(Number(rooms) + 1)}
                      //       >
                      //         <span className="onclick_btn" id="adult_plus">
                      //           +
                      //         </span>
                      //       </button>
                      //     </div>
                      //   </div>
                      //   <div>
                      //     {childAge.map((age, index) => (
                      //       <div
                      //         className="agent flex items-center gap-2"
                      //         key={index}
                      //       >
                      //         <span>
                      //           Child{" "}
                      //           <small style={{ fontSize: "12px" }}>
                      //             {" "}
                      //             ({age} Yrs){" "}
                      //           </small>
                      //         </span>
                      //         <div
                      //           className="remove_svg"
                      //           onClick={() => handleRemoveChild(index)}
                      //         >
                      //           <svg
                      //             width="18"
                      //             height="18"
                      //             viewBox="0 0 18 18"
                      //             fill="none"
                      //             xmlns="http://www.w3.org/2000/svg"
                      //           >
                      //             <mask
                      //               id="mask0_6577_13294"
                      //               style={{ maskType: "alpha" }}
                      //               maskUnits="userSpaceOnUse"
                      //               x="0"
                      //               y="0"
                      //               width="18"
                      //               height="18"
                      //             >
                      //               <rect width="18" height="18" />
                      //             </mask>
                      //             <g mask="url(#mask0_6577_13294)">
                      //               <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                      //             </g>
                      //           </svg>
                      //         </div>
                      //       </div>
                      //     ))}

                      //     {/* Add a child button */}
                      //     <div
                      //       className="flex align_items_center justify_content_between border"
                      //       style={{
                      //         padding: "10px ",
                      //         marginBottom: "10px",
                      //         fontWeight: "400",
                      //       }}
                      //       onClick={() =>
                      //         setShowGuestDetailsPopup(!showGuestDetailsPopup)
                      //       }
                      //     >
                      //       Add a Child
                      //       <div>
                      //         <svg
                      //           width="12"
                      //           height="6"
                      //           viewBox="0 0 12 6"
                      //           fill="none"
                      //           xmlns="http://www.w3.org/2000/svg"
                      //         >
                      //           <path
                      //             d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                      //             fill="#1C1B1F"
                      //           />
                      //         </svg>
                      //       </div>
                      //     </div>

                      //     {/* Child age selection popup */}
                      //     {showGuestDetailsPopup && (
                      //       <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                      //         {availableAges.map((age, i) => (
                      //           <div
                      //             className="new-age-option"
                      //             key={i}
                      //             onClick={() => handleAddChildAge(age)}
                      //             style={{ fontWeight: "400" }}
                      //           >
                      //             {age} Years
                      //           </div>
                      //         ))}
                      //       </div>
                      //     )}
                      //   </div>
                      // </div>
                      <GuestDetailsPopup
                        guestDetails={guestDetails}
                        setIsguestDetails={setIsguestDetails}
                        adult={adult}
                        setAdults={setAdults}
                        children={children}
                        setChildren={setChildren}
                        rooms={storeRoomsData}
                        setRooms={setStoreRoomsData}
                        onRoomsChange={setStoreRoomsData}
                        handleRoomsUpdate={setStoreRoomsData}
                        setChildAge={setChildAge}
                        onAdultChange={setAdults}
                        childAge={childAge}
                        removeRoom={removeRoom}
                        onAdultIncrease={onAdultIncrease}
                        onAdultDecrease={onAdultDecrease}
                        toggleGuestDetailsPopup={toggleGuestDetailsPopup}
                        addRoom={addRoom}
                        addChildAge={addChildAge}
                        removeChild={removeChild}
                        availableAges={[2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
                      />
                    )}
                  </p>
                </div>

                <div className={styles?.searchButtonDiv}>
                  <button type="submit" className={styles.submitButton}>
                    Search
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <mask
                          id="mask0_6818_5962"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="18"
                        >
                          <rect width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_6818_5962)">
                          <path
                            d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </span>
                  </button>
                </div>
              </form>
            )}
          </div>{" "}
        </div>
      </section>

      {(guestDetails || destinationToggle || selectDates) && (
        <div
          onClick={() => [
            setIsguestDetails(false),
            setdestinationToggle(false),
            setselectDates(false),
          ]}
          className="ScreenDimmer"
        ></div>
      )}
    </>
  );
}

export default NewUiSearchFormHotels;
